/*
 * Home Actions
 *
 * Actions change things in your application
 * Since this boilerplate uses a uni-directional data flow, specifically redux,
 * we have these actions which are the only way your application interacts with
 * your application state. This guarantees that your state is up to date and nobody
 * messes it up weirdly somewhere.
 *
 * To add a new Action:
 * 1) Import your constant
 * 2) Add a function like this:
 *    export function yourAction(var) {
 *        return { type: YOUR_ACTION_CONSTANT, var: var }
 *    }
 */
import {BUSINESS_LOGIN, LOGIN, RESET_BUSINESS, RESET_USER} from './constants';
import HttpClient from '../../utils/httpClient';


/*export function loginUser(data) {
  return (dispatch) => HttpClient.postLogout(data, dispatch, LOGIN, 'v4/login/business/');
}*/

// Acción para iniciar sesión de usuario
export const loginUser = (data) => (dispatch) =>
  HttpClient.postLogout(data, dispatch, LOGIN, 'v5/login/business/');

// Acción para buscar empresa por subdominio
export const searchBusiness = (domain) => (dispatch) =>
  HttpClient.getLogout(dispatch, BUSINESS_LOGIN, `v5/companies/subdomain/${domain}/`);

// Acción para limpiar datos de empresa
export const cleanBusiness = () => ({
  type: RESET_BUSINESS,
});

// Acción para limpiar datos de usuario
export const cleanUser = () => ({
  type: RESET_USER,
});
